<template>
	<xm-page class="pay-success-page">
        <xm-page-content >
            <div class="success-content">
                <div class="img-wrap">
                   <img :src="images.paySuccess" alt="">
                </div>
                <div class="tip">
                    <div class="tip-text">
                        支付成功
                    </div>
                    <div class="tip-desc">
                        <div>关注机构微信公众号</div>
                        <div>在「我的-订单记录」中查看订单记录</div>
                    </div>
                </div>
                <div class="opera-area">
                    <xm-button class="mall-btn" @click="toMall">进入在线商城</xm-button>
                    <xm-button class="order-btn" @click="toOrderDetail">查看订单详情</xm-button>
                </div>
            </div>
        </xm-page-content>
	</xm-page>
</template>
<script>
    import paySuccess from '@/images/renew/pay-success.png';
    export default {
   	 	data() {
            return{
                images: {
                    paySuccess,
                },
                instName:this.$route.query.instName
            }
        },
        created(){
          
        },
        mounted(){

        },
        methods: {
           toMall(){
                window.router.replace({
                    name: 'online_product_list',
                    query: {
                        instId:this.$route.query.instId,
                        instName:this.$route.query.instName
                    }
                });
           },
            toOrderDetail(){
                window.router.replace({
                    name: "voucher_detail",
                    query: {
                        voucherId:this.$route.query.voucherId
                    }
                });
           }
        },
        components:{
           
        },
    }
</script>
<style lang="less">
	@import url(../../core/mixins.less);
    .pay-success-page{
        .success-content{
          text-align:left;
          padding:1.7rem 0.32rem 0 0.32rem;
          .img-wrap{
            text-align:center;
            img {
                width: 1.2rem;
                height: 1.2rem;
            }
          }
          .tip{
            margin-bottom:0.8rem;
            .tip-text{
                color:#333333;
                font-size:0.34rem;
                line-height:0.48rem;
                text-align:center;
            }
            .tip-desc{
                font-size:0.26rem;
                color:rgba(153,153,153,1);
                line-height:0.36rem;
                text-align:center;
                margin-top:0.18rem;
            }
          }
           .opera-area{
               display:flex;
               justify-content: space-between;
                .mall-btn{
                  width:3.28rem;
                  background: #FFF;
                  color:#FF6934;
                  border:1px solid #FF6934;
                  font-size:0.3rem;
                  border-radius:0.1rem;
                }
                .order-btn{
                  width:3.28rem;
                  background-image: linear-gradient(to right, #FF7819 , #FF4200);
                  color:#FFF;
                  border:1px solid #FF6934;
                  font-size:0.3rem;
                  border-radius:0.1rem;

                }
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/module/mall/PaySuccess.vue